import React from "react";
import { RemovableLabel, type RemovableProps } from "./Removable";
import UserWithAvatar from "components/Atoms/UserWithAvatar";

type Props = RemovableProps<server.dto.UserToClientSmall>;

export const RemovableUserToClient = (props: Props) => {
  return <RemovableLabel
    {...props}
  >
    <UserWithAvatar user={props.value.user} avatarSize="avatar-30" />
  </RemovableLabel>;
};